/**
 * The browser tab title, from the specific to the general (BRAND.md "Page
 * titles"): `<Page> | <Section> | <product>`. The Shell composes it from the
 * breadcrumbs, and a page heading names a record the breadcrumbs only call
 * "Detail". A page can set its own with `useDocumentTitle`.
 */
import { createContext, useContext, useEffect } from "react";

export type TitleRegistry = { crumbs: (parts: string[]) => void; heading: (title: string) => () => void };
export const TitleCtx = createContext<TitleRegistry | null>(null);

/** Names this page in the tab title while it is mounted. */
export function useDocumentTitle(title: string | null | undefined) {
  const reg = useContext(TitleCtx);
  useEffect(() => (reg && title ? reg.heading(title) : undefined), [reg, title]);
}

const GENERIC = new Set(["Detail", "Details"]);

export function composeTitle(crumbs: string[], heading: string | null | undefined, product: string, sub?: string): string {
  const parts = crumbs.map((c) => c.trim()).filter((c) => c && c !== "…");
  if (parts.length && (parts[0] === sub || parts[0] === product)) parts.shift();
  if (heading && !parts.includes(heading)) {
    if (!parts.length || GENERIC.has(parts[parts.length - 1])) parts.splice(Math.max(0, parts.length - 1), 1, heading);
  }
  // The three most specific parts are enough to tell tabs apart; the rest would only push the product out of sight.
  return [...parts.slice(-3).reverse(), product].join(" | ");
}
